import { useState } from "react";
import constate from "constate";

const PAGE_SIZE = 30;

const [PaginatedListingListProvider, usePaginatedListingList] = constate(() => {
  const [listParams, setListParams] = useState({
    list: "uploaded",
    query: "",
    sort: { field: "refreshed_at", direction: "desc" },
    paging: { offset: 0, limit: PAGE_SIZE },
    filters: {},
  });
  const [searchQuery, setSearchQuery] = useState("");
  const [page, setPage] = useState(1);
  const [sort, setSort] = useState("refreshed_at|desc");
  const [filter, setFilter] = useState(null);
  const [inStock, setInStock] = useState(false);
  const [isConsignment, setConsignment] = useState(false);
  const [count, setCount] = useState(null);

  const onSortChange = (sort) => {
    const sortArr = sort.split("|");
    setListParams((params) => ({
      ...params,
      sort: { field: sortArr[0], direction: sortArr[1] },
      paging: { offset: 0, limit: PAGE_SIZE },
    }));
    setSort(sort);
    setPage(1);
  };

  const onSearchQueryChange = (query) => {
    setListParams((params) => ({
      ...params,
      query,
      paging: { offset: 0, limit: PAGE_SIZE },
    }));
    setSearchQuery(query);
    setPage(1);
  };

  const onFilterChange = (filter) => {
    setListParams((params) => ({
      ...params,
      filters: {
        status: [filter],
      },
      paging: { offset: 0, limit: PAGE_SIZE },
    }));
    setFilter(filter);
    setPage(1);
  };

  const onInStockChange = ({
    inStock: nextInStock,
    isConsignment: nextConsignment,
  }) => {
    const effectiveInStock =
      typeof nextInStock !== "undefined" ? nextInStock : inStock;
    const effectiveConsignment =
      typeof nextConsignment !== "undefined" ? nextConsignment : isConsignment;

    setListParams((params) => {
      const next = [];
      if (effectiveInStock) next.push("owned");
      if (effectiveConsignment) next.push("exclusive");
      return {
        ...params,
        filters: {
          ...params.filters,
          in_stock: next.length ? next : undefined,
        },
        paging: { offset: 0, limit: PAGE_SIZE },
      };
    });

    if (typeof nextInStock !== "undefined") {
      setInStock(nextInStock);
    }

    if (typeof nextConsignment !== "undefined") {
      setConsignment(nextConsignment);
    }
    setPage(1);
  };

  const onPageChange = (page) => {
    setListParams((params) => ({
      ...params,
      paging: {
        ...params.paging,
        offset: (page - 1) * PAGE_SIZE,
      },
    }));
    setPage(page);
  };

  return {
    searchQuery,
    onSearchQueryChange,
    sort,
    onSortChange,
    filter,
    onFilterChange,
    inStock,
    isConsignment,
    onInStockChange,
    count,
    setCount,
    listParams,
    page,
    onPageChange,
  };
});

export { PaginatedListingListProvider, usePaginatedListingList };
